import { Result } from '../Result';

export type LoadScriptResult = Result<HTMLScriptElement, ErrorEvent>;

export function loadScript(url: string, async = true) {
	return new Promise<LoadScriptResult>((resolve, reject) => {
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.async = async;
		script.src = url;

		script.addEventListener('load', () => {
			resolve(Result.Ok(script));
		});

		script.addEventListener('error', (error) => {
			resolve(Result.Error(error));
		});

		document.body.appendChild(script);
	});
}
